import StyledInput from 'components/styledInput/StyledInput';
import SectorOfActivity from './sectorOfActivity';

const CompanyQualificationSection = ({
  companyList,
  company,
  errorsCompany,
  handleChangeCompany,
  qualificationList,
  qualification,
  errorsQualification,
  handleChangeQualification,
  setDataCreateMission,
  sectors,
  selectedSector,
  onSectorToggle,
  onForceSectorSelect,
  lastMissionSuggestions,
  activeQualifications,
}) => {
  const onCompanyChange = (updatedCompanyList) => {
    const checkedItem = updatedCompanyList.find((item) => item.checked);
    handleChangeCompany(updatedCompanyList);
    setDataCreateMission((prev) => ({
      ...prev,
      company: checkedItem?.value || '',
      idLocation: checkedItem?.location || null,
    }));
  };

  const onQualificationChange = (updatedQualificationList) => {
    const checkedItem = updatedQualificationList.find((item) => item.checked);
    handleChangeQualification(updatedQualificationList);
    setDataCreateMission((prev) => ({
      ...prev,
      qualification: checkedItem?.value || '',
      title: checkedItem?.label || '',
    }));
    if (checkedItem?.type) {
      onForceSectorSelect(checkedItem.type);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <StyledInput
        type="selectMultipleRadio"
        label="Sélectionner l'entreprise"
        value={
          companyList?.find((item) => item.value === company.name)?.label || '-'
        }
        list={companyList?.map((item) => ({
          ...item,
          checked: item.value === company.name,
        }))}
        onChange={onCompanyChange}
        isSearchable
        error={errorsCompany.name}
      />
      <SectorOfActivity
        sectors={sectors}
        selectedSector={selectedSector}
        onSelectSector={onSectorToggle}
      />
      <StyledInput
        type="selectMultipleRadio"
        label="Qualification"
        value={
          qualificationList?.find((item) => item.value === qualification.name)
            ?.label || '-'
        }
        list={qualificationList?.map((item) => ({
          ...item,
          checked: item.value === qualification.name,
        }))}
        onChange={onQualificationChange}
        isSearchable
        error={errorsQualification.name}
        listSuggestions={lastMissionSuggestions}
        onClickSuggestion={(suggestion) => {
          const newQualList = activeQualifications
            .filter((q) => q.type === suggestion.type)
            .map((q) => ({
              value: q._id,
              label: q.name,
              type: q.type,
              checked: q._id === suggestion.id,
            }));
          onQualificationChange(newQualList);
        }}
      />
    </div>
  );
};

export default CompanyQualificationSection;
